import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SelectedInvoiceState {
  selectedInvoice: any;
}

const initialState: SelectedInvoiceState = {
  selectedInvoice: "jkkj",
};

const SelectedInvoiceReducer = createSlice({
  name: "selectedInvoice",
  initialState,
  reducers: {
    setSelectedInvoice(state, action: PayloadAction<any>) {
      state.selectedInvoice = action.payload;

      localStorage.setItem("invoice", JSON.stringify(action.payload));
    },
  },
});

export const { setSelectedInvoice } = SelectedInvoiceReducer.actions;
export default SelectedInvoiceReducer.reducer;
